<script>
export default {
  name: 'AlertWithRetry',
  props: {
    message: {
      type: String,
      default: '',
    },
  },
};
</script>

<template>
  <div class="alert-with-retry">
    <i class="el-icon-warning alert-with-retry__icon" />

    <div class="alert-with-retry__message">
      {{ message || $t('FAILED_TO_FETCH') }}
    </div>

    <div>
      <ElButton
        type="danger"
        plain
        icon="el-icon-refresh"
        class="alert-with-retry__button"
        @click="$emit('retry')"
      >
        {{ $t('RETRY') }}
      </ElButton>
    </div>
  </div>
</template>

<style lang="scss">
.alert-with-retry {
  padding: 1rem;
  border-radius: 12px;
  background: #ffeaee;
  display: flex;
  align-items: center;
  gap: 1rem;
  font-size: 0.9rem;

  &__icon {
    vertical-align: middle;
    font-size: 140%;
    color: #df2648;
  }

  &__message {
    flex: 1;
  }

  &__button {
    background-color: $--color-white !important;
    border-color: transparent !important;

    &:focus {
      background-color: $--color-white !important;
      color: $--color-danger !important;
    }

    &:hover {
      background-color: $--color-danger !important;
      color: $--color-white !important;
    }

    &:active {
      background-color: color.scale(
        $--color-danger,
        $lightness: -10%
      ) !important;
      color: $--color-white !important;
    }
  }
}
</style>
